import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { PercPipe } from '../../../../../pipes/perc.pipe';
import { RoundSigPipe } from '../../../../../pipes/roundsig.pipe';
import { User } from '../../../../../models/User';
import { CustomItemContext } from 'app/components/data-table/data-table.component';
import { ChartData } from '../../../charts/models/ChartData';

declare var jQuery;

@Component({
  selector: 'domain-inventory',
  templateUrl: './domain-inventory.html',
  styleUrls: ['./domain-inventory.css']
})
export class DomainInventory implements AfterViewInit, OnChanges {
  @Input() region;
  @Input() country;
  @Input() month;
  @Input() appName;
  @Input() isFollowing: boolean;
  @Output() anchorClick: EventEmitter<any> = new EventEmitter<any>();

  graphTitle = '';
  chartData: Array<any>;
  private currentType = 'hour';

  inventoryDistribution: any;
  programmaticInventory: any;

  toggle0 = false;
  toggle1 = false;
  toggle2 = false;
  toggle3 = false;

  headerCountries = [];
  headerCountriesByRegion = [];
  headerRegions = [];
  headerAdSizes = [];
  headerDmas = [];

  countries = [];
  countriesByRegion = [];
  regions = [];
  adSizes = [];
  dmas = [];

  percPipe = new PercPipe();
  roundSig = new RoundSigPipe();
  lineChartData: Array<ChartData>;

  @ViewChild('regionTemplate') regionTemplate: TemplateRef<CustomItemContext>;
  @ViewChild('usRegionTemplate')
  usRegionTemplate: TemplateRef<CustomItemContext>;

  get isFreemium(): boolean {
    return this.userService.isFreemium();
  }

  constructor(private userService: User) {}

  ngAfterViewInit() {
    // Header Countries
    this.headerCountries.push({
      class: 'col-4',
      text: 'REGION CODE',
      key: 'region',
      tooltipkey: ''
    });
    this.headerCountries.push({
      class: 'col text-right',
      text: 'INVENTORY',
      format: 'percent',
      key: 'totalInventoryRatio',
      lockInFreemium: true,
      tooltipkey: ''
    });
    this.headerCountries.push({
      class: 'col text-right',
      text: 'IVT',
      format: 'percent',
      key: 'givtSivtRate',
      lock: () => this.isFreemium && !this.isFollowing,
      tooltipkey: ''
    });
    this.headerCountries.push({
      class: 'col text-right',
      text: 'VIEWABILITY',
      format: 'percent',
      key: 'viewability',
      tooltipkey: ''
    });
    // Header Countries By Region
    this.headerCountriesByRegion.push({
      class: 'col-4',
      text: 'COUNTRY NAME',
      key: 'countryName',
      tooltipkey: ''
    });
    this.headerCountriesByRegion.push({
      class: 'col text-right',
      text: 'INVENTORY',
      format: 'percent',
      key: 'totalInventoryRatio',
      lockInFreemium: true,
      tooltipkey: ''
    });
    this.headerCountriesByRegion.push({
      class: 'col text-right',
      text: 'IVT',
      format: 'percent',
      key: 'givtSivtRate',
      lock: () => this.isFreemium && !this.isFollowing,
      tooltipkey: ''
    });
    this.headerCountriesByRegion.push({
      class: 'col text-right',
      text: 'VIEWABILITY',
      format: 'percent',
      key: 'viewability',
      tooltipkey: ''
    });
    // Header Regions
    if (this.region !== 'NON-US') {
      this.headerRegions.push({
        class: 'col-4',
        text: 'STATE NAME',
        key: 'regionName',
        tooltipkey: ''
      });
    } else {
      this.headerRegions.push({
        class: 'col-4',
        text: 'COUNTRY NAME',
        key: 'regionName',
        tooltipkey: ''
      });
    }
    this.headerRegions.push({
      class: 'col text-right',
      text: 'INVENTORY',
      format: 'percent',
      key: 'totalInventoryRatio',
      lockInFreemium: true,
      tooltipkey: ''
    });
    this.headerRegions.push({
      class: 'col text-right',
      text: 'IVT',
      format: 'percent',
      key: 'givtSivtRate',
      lock: () => this.isFreemium && !this.isFollowing,
      tooltipkey: ''
    });
    this.headerRegions.push({
      class: 'col text-right',
      text: 'VIEWABILITY',
      format: 'percent',
      key: 'viewability',
      tooltipkey: ''
    });
    // Header Ad Sizes
    this.headerAdSizes.push({
      class: 'col-4',
      text: 'AD SIZE',
      key: 'adSize',
      tooltipkey: ''
    });
    this.headerAdSizes.push({
      class: 'col text-right',
      text: 'INVENTORY',
      format: 'percent',
      key: 'totalInventoryRatio',
      lockInFreemium: true,
      tooltipkey: ''
    });
    this.headerAdSizes.push({
      class: 'col text-right',
      text: 'IVT',
      format: 'percent',
      key: 'givtSivtRate',
      lock: () => this.isFreemium && !this.isFollowing,
      tooltipkey: ''
    });
    this.headerAdSizes.push({
      class: 'col text-right',
      text: 'VIEWABILITY',
      format: 'percent',
      key: 'viewability',
      tooltipkey: ''
    });
    // Header DMAS
    this.headerDmas.push({
      class: 'col-4',
      text: 'DMA NAME',
      key: 'dmaName',
      tooltipkey: ''
    });
    this.headerDmas.push({
      class: 'col text-right',
      text: 'INVENTORY',
      format: 'percent',
      key: 'totalInventoryRatio',
      lockInFreemium: true,
      tooltipkey: ''
    });
    this.headerDmas.push({
      class: 'col text-right',
      text: 'IVT',
      format: 'percent',
      key: 'givtSivtRate',
      lock: () => this.isFreemium && !this.isFollowing,
      tooltipkey: ''
    });
    this.headerDmas.push({
      class: 'col text-right',
      text: 'VIEWABILITY',
      format: 'percent',
      key: 'viewability',
      tooltipkey: ''
    });
    // Initialize Table Data
    this.prepareData();
    setTimeout(fn => {
      jQuery('[data-toggle="tooltip"]').tooltip({ animation: false });
    }, 100);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.prepareData();
    if (changes.country && this.country) {
      if (this.country.value && this.country.value == 'GLOBAL') {
        this.graphTitle = this.region;
      } else if (this.country.label) {
        const start = this.country.label.indexOf('>');
        this.graphTitle = this.country.label.slice(start + 1);
      }
    }
  }

  prepareData() {
    if (
      this.inventoryDistribution['countries'] &&
      this.inventoryDistribution['countries'].length > 0
    ) {
      this.countries = JSON.parse(
        JSON.stringify(
          this.inventoryDistribution['countries'].filter(
            country => country.countryCode !== 'GLOBAL'
          )
        )
      );
      this.prepareTemplate(this.countries);
    }

    if (
      this.inventoryDistribution['countriesByRegion'] &&
      this.inventoryDistribution['countriesByRegion'].length > 0
    ) {
      this.countriesByRegion = JSON.parse(
        JSON.stringify(this.inventoryDistribution['countriesByRegion'])
      );
      this.prepareTemplate(this.countriesByRegion);
    }

    if (
      this.inventoryDistribution['regions'] &&
      this.inventoryDistribution['regions'].length > 0
    ) {
      this.regions = JSON.parse(
        JSON.stringify(this.inventoryDistribution['regions'])
      );
      this.prepareTemplate(this.regions);
    }

    if (
      this.inventoryDistribution['adSizes'] &&
      this.inventoryDistribution['adSizes'].length > 0
    ) {
      this.adSizes = JSON.parse(
        JSON.stringify(this.inventoryDistribution['adSizes'])
      );
      this.prepareTemplate(this.adSizes);
    }

    if (
      this.inventoryDistribution['dmas'] &&
      this.inventoryDistribution['dmas'].length > 0
    ) {
      this.dmas = JSON.parse(
        JSON.stringify(this.inventoryDistribution['dmas'])
      );
      this.prepareTemplate(this.dmas);
    }
  }

  prepareTemplate(data) {
    if (data) {
      for (const dataItem of data) {
        dataItem['countryCodeTemplate'] = this.regionTemplate;

        if (this.region !== 'NON-US') {
          dataItem['regionNameTemplate'] = this.usRegionTemplate;
        }
      }
    }
  }

  toggle(n) {
    this['toggle' + n] = !this['toggle' + n];
  }

  @Input()
  set data(value) {
    this.inventoryDistribution = JSON.parse(
      JSON.stringify(value['inventoryDistribution'])
    );
    this.programmaticInventory = JSON.parse(
      JSON.stringify(value['programmaticInventory'])
    );

    const programmaticInventory = this.programmaticInventory;
    if (programmaticInventory) {
      const months = programmaticInventory['months'];
      if (months) {
        months.reverse();
      }

      const days = programmaticInventory['days'];
      if (days) {
        days.reverse();
      }

      const hours = programmaticInventory['hours'];
      if (hours) {
        hours.reverse();
      }
    }

    this.changeChartData(this.currentType);
  }

  changeChartData(type) {
    this.currentType = type;
    switch (type) {
      case 'month':
        this.chartData = JSON.parse(
          JSON.stringify(this.programmaticInventory.months)
        );
        break;
      case 'day':
        this.chartData = JSON.parse(
          JSON.stringify(this.programmaticInventory.days)
        );
        break;
      case 'hour':
        this.chartData = JSON.parse(
          JSON.stringify(this.programmaticInventory.hours)
        );
        break;
    }

    this.lineChartData = this.chartData;
  }
}
